<template>
    <div id="app">
        <Layout />
    </div>
</template>
<script>
    import Layout from './views/layout/Index.vue';
    export default {
        components: {
            Layout
        }

    }
</script>
<style lang="stylus">
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        // text-align: center;
        color: #2c3e50;
    }

    #nav {
        padding: 30px;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }
</style>
